/**
 * Format seconds to duration in HH:MM:SS format.
 *
 * Non-finite and negative inputs are clamped to `0` and fractional seconds are
 * floored, so the output is always three colon-separated numeric groups.
 *
 * @example
 * formatSecondsToDuration(3600) -> "01:00:00"
 * formatSecondsToDuration(3600 + 60) -> "01:01:00"
 * formatSecondsToDuration(3600 + 60 + 1) -> "01:01:01"
 * formatSecondsToDuration(93.5) -> "00:01:33"
 * formatSecondsToDuration(-5) -> "00:00:00"
 */
export const formatSecondsToDuration = (seconds: number): string => {
  const totalSeconds = Number.isFinite(seconds)
    ? Math.max(0, Math.floor(seconds))
    : 0;

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;

  return [
    String(hours).padStart(2, "0"),
    String(minutes).padStart(2, "0"),
    String(remainingSeconds).padStart(2, "0"),
  ].join(":");
};
